export default __webpack_public_path__ + "static/media/Arrecadação (Real Size).bc51e71a.svg";